import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Input,
  Checkbox,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import {
  addLeaveAllocation,
  getLeaveAllocationDetails,
  updateLeaveAllocation,
} from '../../../network/leaveAllocation';
import dayjs from 'dayjs';
import { getSearchApi } from '../../../network/itemList';
import { getEmployee, getEmployeeDetails } from '../../../network/employee';
import {
  addLeaveApplication,
  getLeaveApplicationDetails,
  updateLeaveApplication,
} from '../../../network/LeaveApplication';
import { submitMaterialRequest } from '../../../network/materialRequest';
import HeadingApp from '../../../hooks/HeadingApp';
import { PiBatteryVerticalLow } from 'react-icons/pi';
const AddLeaveApplication = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const watchstatus = Form.useWatch('status', form);
  console.log(watchstatus, 'watchstatus');

  const { mutate: onAddStockEntry } = useMutation({
    mutationKey: ['addStockEntry'],
    mutationFn: (body) =>
      edit ? updateLeaveApplication(body, id) : addLeaveApplication(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectName(edit ? id : data?.data?.name);
      if (watchstatus !== 'Rejected' || watchstatus !== 'Approved') {
        navigate('/leave-application');
        setSubmitButton(false);
      } else {
        setSubmitButton(true);
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getLeaveApplication] });
      // form.resetFields();

      edit && dataStatus !== 0 && navigate('/leave-application');
    },
    onError: (error) => {
      setLoadingAdd(false);
      message.error(error.response.data._server_messages);
      console.log('error:', error);
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Leave Application', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getLeaveApplication] });
      navigate('/leave-application');
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { mutate: onGetEmployee } = useMutation({
    mutationKey: [queryKeys.getEmployeeDetails],
    mutationFn: (value) => getEmployeeDetails(value),
    onSuccess: (data) => {
      console.log(data, 'data');
      form.setFieldsValue({
        employee_name: data?.data?.employee_name,
        department: data?.data?.department,
        leave_approver: data?.data?.leave_approver,
      });
    },
  });
  const { data: leaveAllocationDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getLeaveApplication, id],
    queryFn: () => getLeaveApplicationDetails(id),
    enabled: !!edit,
  });
  const { data: employee } = useQuery({
    queryKey: [queryKeys.getEmployee],
    queryFn: () => getEmployee(),
  });
  const { data: leaveType } = useQuery({
    queryKey: [queryKeys.getSearchApiLeaveType],
    queryFn: () => getSearchApi('Leave Type'),
    keepPreviousData: true,
  });
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddStockEntry({
      ...values,
      company: companyName,
      from_date: dayjs(values?.from_date).format('YYYY-MM-DD'),
      to_date: dayjs(values?.to_date).format('YYYY-MM-DD'),
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      follow_via_email: values?.follow_via_email ? 1 : 0,
      half_day: values?.half_day ? 1 : 0,
    });
  };
  useEffect(() => {
    if (edit && leaveAllocationDetails) {
      setDataStatus(leaveAllocationDetails?.data?.docstatus);
      form.setFieldsValue({
        ...leaveAllocationDetails?.data,
        from_date: dayjs(leaveAllocationDetails?.data?.from_date),
        to_date: dayjs(leaveAllocationDetails?.data?.to_date),
        posting_date: dayjs(leaveAllocationDetails?.data?.posting_date),
      });
    } else {
      form.resetFields();
    }
  }, [edit, leaveAllocationDetails, form]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      <Heading
        title={t.HR}
        subTitle={edit ? t.editLeaveApplication : t.addLeaveApplication}
        path="/leave-application"
      />
      <HeadingApp
        nameTab={t.HR}
        title={t.LeaveApplication}
        subTitle={edit ? t.editLeaveApplication : t.addLeaveApplication}
        icon={<PiBatteryVerticalLow />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-leave-application"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee"
                    label={t.Employee}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Employee}
                      showSearch
                      optionFilterProp="children"
                      filterOption={false}
                      onChange={(value, option) => {
                        console.log(option, 'option');
                        onGetEmployee(value);
                        // form.setFieldsValue({
                        //   employee_name: option?.option?.employee_name,
                        //   department: option?.option?.department,
                        //   leave_approver: option?.option?.leave_approver,
                        // });
                      }}
                      // filterSort={(optionA, optionB) =>
                      //   (optionA?.label ?? '')
                      //     .toLowerCase()
                      //     .localeCompare((optionB?.label ?? '').toLowerCase())
                      // }
                      options={employee?.data?.map((user) => ({
                        value: user.name,
                        label: user.name,
                        option: user,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee_name"
                    label={t.employeeName}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.employeeName} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="leave_approver" label={t.leaveApprover}>
                    <Input placeholder={t.leaveApprover} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="leave_type"
                    label={t.LeaveType}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.LeaveType}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={leaveType?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="from_date"
                    label={t.fromDate}
                    rules={[{ required: true }]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      placeholder={t.fromDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="to_date"
                    label={t.ToDate}
                    rules={[{ required: true }]}
                    initialValue={dayjs().add(1, 'days')}
                  >
                    <DatePicker
                      placeholder={t.ToDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[{ required: true }]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      placeholder={t.postingDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="status"
                    label={t.LeaveStatus}
                    rules={[{ required: true }]}
                    initialValue={'Approved'}
                  >
                    <Select
                      placeholder={t.LeaveStatus}
                      options={[
                        { value: 'Open', label: t.openStatus },
                        { value: 'Approved', label: t.approved },
                        { value: 'Rejected', label: t.rejected },
                        { value: 'Cancelled', label: t.cancelled },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="total_leave_days" label={t.totalLeaveDays}>
                    <Input
                      type="number"
                      placeholder={t.totalLeaveDays}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="leave_balance" label={t.leaveBalance}>
                    <Input
                      type="number"
                      placeholder={t.leaveBalance}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'end',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item name="half_day" valuePropName="checked">
                    <Checkbox>{t.halfDay}</Checkbox>
                  </Form.Item>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'end',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item name="follow_via_email" valuePropName="checked">
                    <Checkbox>{t.followViaEmail}</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.cancel}
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      handleSubmit.mutate(selectName);
                    } else {
                      form.submit();
                    }
                  }}
                  loading={loadingAdd}
                >
                  {/* {edit ? t.edit : t.submit} */}
                  {submitButton ? t.submit : edit ? t.edit : t.Save}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddLeaveApplication;
